module.exports = {"TXTWCL_Watch_Trailer":{"id":"TXTWCL_Watch_Trailer","defaultMessage":"Regarder la bande-annonce","flags":["TRACK"],"track":"Watch Trailer"}}